module.exports = __webpack_public_path__ + "media/images/share-linkedin-b7e112bfe04f78a0f1fd3c970494fb7c.svg";